import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "navbar navbar-expand-lg bg-body-tertiary d-print-none",
  id: "main-nav"
}
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = {
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent"
}
const _hoisted_4 = { class: "navbar-nav me-auto mb-2 mb-lg-0" }
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = { class: "form-check nav-checkbox-control" }
const _hoisted_7 = {
  class: "d-flex ms-auto",
  role: "form",
  id: "config"
}
const _hoisted_8 = { class: "input-group" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "input-group" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "input-group" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "input-group" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "container-fluid d-flex align-items-center justify-content-center" }
const _hoisted_17 = {
  id: "main-page",
  class: "shadow-lg rounded"
}
const _hoisted_18 = {
  class: "container",
  id: "page-content-area"
}
const _hoisted_19 = { class: "text-center m-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavItem = _resolveComponent("NavItem")!
  const _component_ExerciseGrid = _resolveComponent("ExerciseGrid")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[12] || (_cache[12] = _createElementVNode("a", {
          class: "navbar-brand",
          href: "#"
        }, "练习题生成器", -1)),
        _cache[13] || (_cache[13] = _createElementVNode("button", {
          class: "navbar-toggler",
          type: "button",
          "data-bs-toggle": "collapse",
          "data-bs-target": "#navbarSupportedContent",
          "aria-controls": "navbarSupportedContent",
          "aria-expanded": "false",
          "aria-label": "Toggle navigation"
        }, [
          _createElementVNode("span", { class: "navbar-toggler-icon" })
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("ul", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.operations, (op) => {
              return (_openBlock(), _createBlock(_component_NavItem, {
                op: op,
                key: op
              }, null, 8, ["op"]))
            }), 128)),
            _createElementVNode("li", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "form-check-input me-2 col-1",
                  id: "input-mixed-question",
                  name: "mixed-question",
                  "aria-label": "求任意值",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.randomQuestion) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.randomQuestion]
                ]),
                _cache[7] || (_cache[7] = _createElementVNode("label", {
                  class: "form-check-label",
                  for: "input-mixed-question"
                }, "求任意值", -1))
              ])
            ])
          ]),
          _createElementVNode("form", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[8] || (_cache[8] = _createElementVNode("label", {
                class: "input-group-text",
                for: "input-min-value"
              }, "最小值", -1)),
              _createElementVNode("input", {
                value: _ctx.min,
                onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateMin && _ctx.updateMin(...args))),
                class: "form-control me-2 col-1",
                id: "input-min-value",
                name: "input-min-value",
                type: "number",
                min: "0",
                max: "100",
                "aria-label": "最小值"
              }, null, 40, _hoisted_9)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[9] || (_cache[9] = _createElementVNode("label", {
                class: "input-group-text",
                for: "input-max-value"
              }, "最大值", -1)),
              _createElementVNode("input", {
                value: _ctx.max,
                onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.updateMax && _ctx.updateMax(...args))),
                class: "form-control me-2 col-1",
                id: "input-max-value",
                name: "input-max-value",
                type: "number",
                min: "0",
                max: "100",
                "aria-label": "最大值"
              }, null, 40, _hoisted_11)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _cache[10] || (_cache[10] = _createElementVNode("label", {
                class: "input-group-text",
                for: "input-result-min-value"
              }, "结果下限", -1)),
              _createElementVNode("input", {
                value: _ctx.resultMin,
                onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.updateResultMin && _ctx.updateResultMin(...args))),
                class: "form-control me-2 col-1",
                id: "input-result-min-value",
                name: "input-result-min-value",
                type: "number",
                "aria-label": "结果下限"
              }, null, 40, _hoisted_13)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _cache[11] || (_cache[11] = _createElementVNode("label", {
                class: "input-group-text",
                for: "input-result-max-value"
              }, "结果上限", -1)),
              _createElementVNode("input", {
                value: _ctx.resultMax,
                onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.updateResultMax && _ctx.updateResultMax(...args))),
                class: "form-control me-2 col-1",
                id: "input-result-max-value",
                name: "input-result-max-value",
                type: "number",
                "aria-label": "结果上限"
              }, null, 40, _hoisted_15)
            ]),
            _createElementVNode("button", {
              class: "btn btn-outline-success",
              onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.shuffle && _ctx.shuffle(...args)), ["prevent"]))
            }, "生成"),
            _createElementVNode("button", {
              class: "btn btn-outline-success ms-2",
              onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.print && _ctx.print(...args)), ["prevent"]))
            }, "打印")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "mt-5" }, null, -1)),
          _createElementVNode("h2", _hoisted_19, _toDisplayString(_ctx.operationName) + "练习题", 1),
          _cache[15] || (_cache[15] = _createElementVNode("div", {
            id: "student-info",
            class: "row my-4 mx-1 px-2"
          }, [
            _createElementVNode("div", { class: "col-2" }, "姓名："),
            _createElementVNode("div", { class: "col-6" }),
            _createElementVNode("div", { class: "col-4 text-end" }, "  年  月  日")
          ], -1)),
          _createVNode(_component_ExerciseGrid)
        ])
      ])
    ])
  ], 64))
}